import { jsx as _jsx } from "react/jsx-runtime";
import { StyleSheet } from 'react-native';
import { theme } from '@xbto/design-system';
import { Box } from '../box';
export const Hr = ({ marginVertical }) => {
    return _jsx(Box, { style: [$.container, { marginVertical }] });
};
const $ = StyleSheet.create({
    container: {
        width: '100%',
        height: 1,
        backgroundColor: theme.color.background.secondary,
    },
});
